module.exports = __webpack_public_path__ + "img/Telescope 2.898ff042.png";